import { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FlexRow } from '../../atoms/layout/Flex'
import Table from '../../atoms/display/Table'
import TableRow from '../../atoms/display/TableRow'
import TableCell from '../../atoms/display/TableCell'
import Checkbox from '../../atoms/inputs/Checkbox'
import IconButton from '../../atoms/inputs/IconButton'
import { ChatIcon, PinIcon, PinnedIcon } from '../../atoms/display/Icons'
import useRouter from '../../../hooks/useRouter'
import ClientMoneyspaceChatDialog from './ClientMoneyspaceChatDialog'
import usePermission from '../../../hooks/usePermission'
import { SessionSelectors } from '../../../store/session/selectors'
import { MoneyspacesActions } from '../../../store/moneyspaces'
import { Moneyspace } from '../../../types/Moneyspace'

type Props = {
  moneyspaces: Moneyspace[]
  selectedMoneyspaceIds?: string[]
  onSelect?: (selected: boolean, moneyspaceId: string) => void
}

export default function ClientMoneyspaceTable({ moneyspaces, selectedMoneyspaceIds = [], onSelect }: Props) {
  const { moneyspace: moneyspaceRouter } = useRouter()
  const [chatDialogMoneyspaceId, setChatDialogMoneyspaceId] = useState<string | null>(null)
  const user = useSelector(SessionSelectors.user)
  const { moneyspacePermissions } = usePermission()
  const dispatch = useDispatch()

  const handlePinned = useCallback(
    (moneyspaceId: string, isPinned: boolean) => {
      if (isPinned) {
        dispatch(MoneyspacesActions.unPinnedMoneyspace({ moneyspaceId }))
      } else {
        dispatch(MoneyspacesActions.pinnedMoneyspace({ moneyspaceId }))
      }
    },
    [dispatch]
  )

  return (
    <Table>
      {moneyspaces.map((moneyspace) => (
        <TableRow key={moneyspace.id}>
          {onSelect && (
            <TableCell size="xxs">
              <Checkbox
                checked={selectedMoneyspaceIds.includes(moneyspace.id)}
                onChange={(checked) => onSelect(checked, moneyspace.id)}
              />
            </TableCell>
          )}
          <TableCell
            onClick={() => {
              moneyspaceRouter(moneyspace.id)
            }}
          >
            {moneyspace.name}
          </TableCell>
          <TableCell size="xs2">
            <FlexRow scroll={false}>
              <IconButton
                label="ピン留め"
                disabled={!moneyspacePermissions.pinned(user)}
                onClick={() => handlePinned(moneyspace.id, moneyspace.isPinned)}
              >
                {moneyspace.isPinned ? <PinnedIcon /> : <PinIcon />}
              </IconButton>
              <IconButton label="メッセージ" onClick={() => setChatDialogMoneyspaceId(moneyspace.id)}>
                <ChatIcon />
              </IconButton>
            </FlexRow>
          </TableCell>
        </TableRow>
      ))}
      <ClientMoneyspaceChatDialog
        moneyspaceId={chatDialogMoneyspaceId}
        onClose={() => setChatDialogMoneyspaceId(null)}
      />
    </Table>
  )
}
